import api from "./api.js";

export default class AlarmApi {
  static async getList(data) {
    return await api.get(`api/alarm`, data);
  }

  static async createAlarm(data) {
    return await api.post(`api/alarm`, data);
  }

  static async deleteAlarm(data) {
    return await api.del(`api/alarm`, data);
  }
}
